import {
  GetEntitiesCachedPayload,
  GetEntitiesPayload,
} from 'app/modules/entities/requests';
import { GetEntitiesResponse } from 'app/modules/entities/responses';

import { ENTITY_QUERY_KEYS } from 'app/modules/entities/queries/keys';

import { post } from 'app/shared/utils/fetchr';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { selectDLEnabledForEntityList } from 'app/shared/featureFlags/selectors';

export const useGetEntities = <T = GetEntitiesResponse>(
  payload: GetEntitiesPayload,
  options?: Omit<
    UseQueryOptions<GetEntitiesResponse, Error, T>,
    'queryKey' | 'queryFn'
  >,
) => {
  const { enabled = true, ...restOptions } = options || {};
  const useNewEndpoint = useSelector(selectDLEnabledForEntityList);

  return useQuery({
    queryFn: () => {
      if (useNewEndpoint) {
        return post<GetEntitiesResponse>(
          '/v1/entities/cached/list',
          payload satisfies GetEntitiesCachedPayload,
        );
      }
      return post<GetEntitiesResponse>('/v1/entities/list', payload);
    },
    queryKey: ENTITY_QUERY_KEYS.getEntities(payload, useNewEndpoint),
    enabled: payload.limit !== 0 && enabled,
    ...restOptions,
  });
};
